/** A labelled input with its error message underneath. */
import type { InputHTMLAttributes, Ref } from 'react';

const INPUT =
  'rounded border border-stone-300 dark:border-stone-600 bg-white dark:bg-[#1a1f1c] px-2 py-1 min-h-[28px] text-sm text-bark-900 dark:text-stone-100';

export default function PayRateField({
  id,
  label,
  error,
  className = '',
  inputRef,
  ...input
}: {
  id: string;
  label: string;
  error: string | undefined;
  inputRef?: Ref<HTMLInputElement>;
} & InputHTMLAttributes<HTMLInputElement>) {
  const errorId = `${id}-error`;
  return (
    <div>
      <label className="block text-xs text-stone-600 dark:text-stone-400" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        ref={inputRef}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? errorId : undefined}
        className={`${INPUT} ${className}`}
        {...input}
      />
      {error && (
        <p id={errorId} role="alert" className="text-xs text-red-700 dark:text-red-400 mt-1">
          {error}
        </p>
      )}
    </div>
  );
}
